import { render } from "./giftCards.vue?vue&type=template&id=967b8ac2&scoped=true"
import script from "./giftCards.vue?vue&type=script&lang=js"
export * from "./giftCards.vue?vue&type=script&lang=js"

import "./giftCards.vue?vue&type=style&index=0&id=967b8ac2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-967b8ac2"]])

export default __exports__